import React, { useRef, useEffect, useState } from 'react';
import { Select, MenuItem, Typography, useTheme, styled, List, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';
import { Moon, SanaCashNewLogoPrimary, SanaCashNewLogoSecondary, Sun } from 'assets/Icon';
import { THEMES } from 'context/ThemeSwitcherContextProvider';
import useChangeTheme from 'hooks/useChangeTheme';
import { useCookies } from 'react-cookie';
import useIsMobileView from 'hooks/useIsMobileView';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import NightsStayIcon from '@mui/icons-material/NightsStay';

function ChangeThemeButton() {
  const theme = useTheme();
  const selectRef = useRef(null);
  const [cookies] = useCookies();
  const changeTheme = useChangeTheme();
  const [_, setCookie] = useCookies(['sana-theme']);
  const [menuProps, setMenuProps] = useState({});
  const isMobileView = useIsMobileView()

  const themes = {
    primary: {
      icon: theme.mode === 'secondary' ? <SanaCashNewLogoPrimary /> : <SanaCashNewLogoSecondary />,
      title: 'ساناکش',
    },
    secondary: {
      icon: <Sun color={theme.palette.text.main} />,
      title: 'روز',
    },
    info: {
      icon: <Moon color={theme.palette.text.main} />,
      title: 'شب',
    },
  };

  const cookieOptions = {
    path: '/',
    maxAge: 31556952,
  };

  const handleChangeTheme = (event) => {
    const selectedTheme = event.target.value;
    changeTheme?.setTheme(THEMES[selectedTheme]);
    setCookie('sana-theme', THEMES[selectedTheme], cookieOptions);
  };

  const handleChangeThemeInMobile = (event) => {
    changeTheme?.setTheme(THEMES[event]);
    setCookie('sana-theme', THEMES[event], cookieOptions);
  };

  useEffect(() => {
    if (selectRef.current && isMobileView) {
      setMenuProps({
        container: selectRef.current,
        keepMounted: true
      });
    }
  }, [selectRef.current, isMobileView]);

  return (
    <div ref={selectRef}>
      {!isMobileView ? (
        <ChangeThemeSelect
          value={changeTheme.theme}
          onChange={handleChangeTheme}
          size="small"
          displayEmpty
          sx={{ ml: 1, color: theme.palette.text.main }}
          MenuProps={menuProps}
        >
          {Object.keys(themes).map((themeKey) => (
            <DesktopMenuItem key={themeKey} value={themeKey} sx={{ justifyContent: "end" }}>
              <Typography pr={1} variant='subtitle1'>
                {themes[themeKey].title}
              </Typography>
              {themes[themeKey].icon}
            </DesktopMenuItem>
          ))}
        </ChangeThemeSelect>

      ) : (
        <List component="div">
          {Object.keys(themes).map((themeKey) => (

            <ListItemButtonStyleItem
              selected={cookies?.["sana-theme"] === themeKey}
              key={`color-theme-${themeKey}`}
              onClick={() => handleChangeThemeInMobile(themeKey)}
            >
              <ListItemIcon>
                {themes[themeKey].icon}
              </ListItemIcon>
              <ListItemText primary={themes[themeKey].title} />
            </ListItemButtonStyleItem>
          ))}
        </List>
      )}
    </div>
  );
}

const ChangeThemeSelect = styled(Select)(() => ({
  ".MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    paddingRight: "0 !important",
  },

  "& > .MuiSvgIcon-root": {
    display: "none"
  },
  "& svg": {
    width: "18px",
    height: "auto"
  },

  "fieldset": {
    border: "none"
  }
}))

const ListItemButtonStyleItem = styled(ListItemButton)(({ theme }) => ({
  flexDirection: "row-reverse",
  padding: theme.spacing(0.5, 4, 0.5, 0),
  borderRadius: "5px",

  ".MuiListItemIcon-root": {
    minWidth: "35px",
    justifyContent: "flex-end",
    color: theme.palette.common.white,

    svg: {
      width: "18px",
      height: "auto"
    }
  },

  ".MuiListItemText-root": {
    textAlign: "right",
  },
}));

const DesktopMenuItem = styled(MenuItem)(({ theme }) => ({
  "& svg": {
    width: "18px",
    height: "auto"
  }
}));


export default ChangeThemeButton;
